import styles from "./InputBlock.module.scss";

import { useState } from "react";

// components
import { Heading, Input } from "../../Components";

export default function InputBlock() {
  const [value, setValue] = useState<string>("");

  return (
    <div className={styles["input-block-root"]}>
      <Heading title="Input" />

      <div style={{ marginTop: "32px" }} />

      <div className={styles["block"]}>
        <span className={styles["label"]}>Default</span>
        <Input
          id="input-default"
          name="input-default"
          type="text"
          label="Label text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Placeholder text"
        />
      </div>
    </div>
  );
}
